module.exports = __webpack_public_path__ + "img/Voucher Valid.08ba5986.png";